'use strict';

var $Object = require('es-object-atoms');

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/get-proto/Object.getPrototypeOf.js
// module id = ../../../../get-proto/Object.getPrototypeOf.js
// module chunks = 5